export default "__VITE_ASSET__B6sfV274__"